import * as React from 'react';
import { Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Select, SelectItem } from '../../../ui-components/select/Select';
import DatePicker from '../../../ui-components/DatePicker/DatePicker';
import WeekPicker from '../../../ui-components/WeekPicker/WeekPicker';

interface IProps {
    roomList: SelectItem[];
    roomSelected: SelectItem;
    setRoomSelected: (selected: SelectItem) => void;
    dayView: Date;
    filterDate: Date;
    setFilterDate: (day: Date) => void;
    viewType: "day" | "week";
    classes: any;
    smallScreen: boolean;
    disabled: boolean;
}

const getSelectRooms = (props: IProps) => {
    return (<Grid item className={props.smallScreen ? props.classes.SmallSearchSection : props.classes.SearchSection}>
        <Select items={props.roomList}
            disabled={props.disabled}
            selected={props.roomSelected}
            onChange={props.setRoomSelected}
            label={"Elenco Stanze"}
            fullWidth={true}
        />
    </Grid>)
}

const getRadioRooms = (props: IProps) => {
    return (<Grid item className={props.smallScreen ? props.classes.SmallSearchSection : props.classes.SearchSection}>
        <FormControl component="fieldset" style={{ width: "100%" }}>
            <FormLabel component="legend">Stanza</FormLabel>
            <RadioGroup aria-label="room" name="rooms1"
                style={props.smallScreen ? {} : { flexDirection: "row" }}
                value={props.roomSelected ? props.roomSelected.value : undefined} onChange={(e, v) => {
                    let selected = props.roomList.find(room => room.value === v);
                    props.setRoomSelected(selected);
                }}>
                {props.roomList.map(room => {
                    return (<FormControlLabel value={room.value} control={<Radio />} label={room.name} />)
                })}
            </RadioGroup>
        </FormControl>
    </Grid>)
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => {
    return (
        <Grid container className={props.classes.SearchContainer}>
            <Grid container>
                {props.roomList.length > 5 ? getSelectRooms(props) : getRadioRooms(props)}
                <Grid item className={props.smallScreen ? props.classes.SmallSearchSection : props.classes.SearchSection}>
                    {props.viewType === "day" &&
                        <DatePicker key="day-room"
                            disabled={props.disabled}
                            label={"Giorno"}
                            value={props.filterDate}
                            onChange={props.setFilterDate} />}
                    {props.viewType === "week" &&
                        <WeekPicker key="week-room"
                            disabled={props.disabled}
                            label={"Settimana"}
                            value={props.filterDate}
                            onChange={props.setFilterDate}
                            fullWidth />}
                </Grid>
                {/* <Grid item className={props.classes.searchButtons}>
                    <div className={props.classes.searchButton}>
                        <Button disabled={props.roomSelected === undefined || props.areLoadingReservationRooms}
                            onClick={() => props.loadReservationRoom(props.viewType, props.filterDate)}>Cerca</Button>
                    </div>
                </Grid> */}
            </Grid>
        </Grid>
    );
}